
import { useState, useEffect, useRef } from 'react'
import './styles/disponibilidad.css'
import Action from '../Action'
import SearchHost from '../SearchHost'
import { useFetch } from '../../hooks/useFetch'
import { useFetchPost } from '../../hooks/useFetchPost'
import SelectorAdmin from '../SelectorAdmin'
import LoadAdding from '../LoadAdding'
import LoadSimple from '../LoadSimple'
import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import { LineChart, AreaChart, Line, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import MenuSearch from './MenuSearch'
import ModalAddMultiGraph from './ModalAddMultiGraph'
import Search from '../generales/Search'
import { capitalizeFirstLetter } from '../../utils/utils'
import { lang } from '../generales/traduction'
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import isAfter from 'date-fns/isAfter';
// import subDays from 'date-fns/subDays';
// import startOfWeek from 'date-fns/startOfWeek';
// import endOfWeek from 'date-fns/endOfWeek';
// import addDays from 'date-fns/addDays';
// import startOfMonth from 'date-fns/startOfMonth';
// import endOfMonth from 'date-fns/endOfMonth';
// import addMonths from 'date-fns/addMonths';
import { addHours, subHours, addDays, subDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, addMonths } from 'date-fns';
// import UserList from './UserList'
const AddMultiGraphModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '70%',
    padding: '20px',

  },
};
const CustomTooltip = ({ active, payload, label }) => {


  try {
    const objetoOrdenado = payload.sort((a, b) => a.value - b.value)

    if (active && payload) {
      return (
        <div className="custom-tooltip-disponibilidad">
          <div className="cont-tooltip-disponibilidad">
            <div className='row-tooltip'><p className='title-tooltip' style={{ color: 'var(--main-color)', fontSize: '(--font-size-small)' }}>Fecha:&nbsp;</p><p style={{ color: 'var(--txt-color)', fontSize: '(--font-size-xSmall)' }}>{label}</p></div>
            {objetoOrdenado.slice(0, 15).map((element, index) => (
              <div className='row-tooltip'><p style={{ color: element.stroke, fontSize: 'x-small' }} >{`  ${element.name}: `}&nbsp;</p><p style={{ color: '#505050', fontSize: 'x-small', fontWeight: 'bold' }}>{element.value.toFixed(2)}</p></div>


            ))}
            {
              (objetoOrdenado.length > 15) ? <div className='row-tooltip' style={{ fontSize: 'x-small', color: '#505050' }}>Mostrando 15 de {objetoOrdenado.length} elementos . . .</div> : ''
            }
          </div>

        </div>
      );
    }

    return null;
  } catch (error) { }

};
const Disponibilidad = ({ server, languaje, mode }) => {
  const color_graf = {
    1: "#c680ff", 2: "#80cfff", 3: "#56e1ad", 4: "#3b83bd", 5: "#6285aa",
    6: "#7a8697", 7: "#8c8884", 8: "#9a8a71", 9: "#a68d5d", 10: "#b18f47",
    11: "#3b83bd", 12: "#346c9b", 13: "#2d567a", 14: "#25415a", 15: "#1d2c3d",
    16: "#131a21", 17: "#7f4a83", 18: "#86518a", 19: "#8e5892", 20: "#955f99",
    21: "#9d66a0", 22: "#a46da8", 23: "#ac74b0", 24: "#614064", 25: "#49314a",
    26: "#b4031c", 27: "#bc1521", 28: "#c52127", 29: "#cd2b2d", 30: "#d53433",
    31: "#de3d39", 32: "#e6453f", 33: "#cd2b2d", 34: "#dc574c", 35: "#e87b6d",
    36: "#f29c90", 37: "#fabdb4", 38: "#00a87f", 39: "#00b48a", 40: "#00c096",
    41: "#00cca1", 42: "#27d8ac", 43: "#3ce5b8", 44: "#4df1c4", 45: "#80debf",
    46: "#a3e7cf", 47: "#393939", 48: "#5c5c5c", 49: "#828282", 50: "#aaaaaa",
  }
  const generateColorOptions = () => {
    const colorOptions = {};

    for (let i = 1; i <= 100; i++) {
      const red = Math.floor((255 * i) / 100);
      const green = Math.floor((255 * (100 - i)) / 100);
      const blue = Math.floor((255 * (i % 50)) / 50);

      const color = `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;

      colorOptions[i] = color;
    }

    return colorOptions[Math.floor(Math.random() * 100) + 1];
  };

  const getMunicipalityColor = (name, fallbackId) => {
    if (!name) return color_graf[fallbackId];
    const normName = name.toUpperCase();
    if (normName.includes("COYOAC")) return color_graf[1];
    if (normName.includes("TLALPAN")) return color_graf[2];
    if (normName.includes("CUAUHT")) return color_graf[3];
    if (normName.includes("MIGUEL")) return color_graf[4];
    if (normName.includes("BENITO")) return color_graf[5];
    return color_graf[fallbackId];
  };

  const obtenerPrimerDiaDelMes = () => {
    const hoy = new Date();
    const primerDiaDelMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);

    const anio = primerDiaDelMes.getFullYear();
    const mes = String(primerDiaDelMes.getMonth() + 1).padStart(2, '0');
    const dia = String(primerDiaDelMes.getDate()).padStart(2, '0');
    const horas = String(primerDiaDelMes.getHours()).padStart(2, '0');
    const minutos = String(primerDiaDelMes.getMinutes()).padStart(2, '0');

    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const haceNHoras = new Date(ahora.getTime() - (0 * 60 * 60 * 1000));
    const anio = haceNHoras.getFullYear();
    const mes = String(haceNHoras.getMonth() + 1).padStart(2, '0');
    const dia = String(haceNHoras.getDate()).padStart(2, '0');
    const horas = String(haceNHoras.getHours()).padStart(2, '0');
    const minutos = String(haceNHoras.getMinutes()).padStart(2, '0');

    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  };



  const originDataLocations = useFetch('zabbix/groups/municipios', '', localStorage.getItem('access_token'), 'GET', server);

  // Intercept dataLocations to provide CDMX Delegaciones
  const dataLocations = React.useMemo(() => {
    if (!originDataLocations.loading && originDataLocations.data?.data) {
      const cdmxDelegaciones = [
        { id: 1, name: "Coyoacán", groupid: 1 },
        { id: 2, name: "Tlalpan", groupid: 2 },
        { id: 3, name: "Cuauhtémoc", groupid: 3 },
        { id: 4, name: "Miguel Hidalgo", groupid: 4 },
        { id: 5, name: "Benito Juárez", groupid: 5 }
      ];
      const originalData = originDataLocations.data.data || [];
      const newData = cdmxDelegaciones.map((del, i) => {
        if (originalData[i]) {
          return { ...originalData[i], name: del.name };
        }
        return { ...del, id: 990 + i, groupid: 990 + i };
      });
      return {
        ...originDataLocations,
        data: {
          ...originDataLocations.data,
          data: newData
        }
      };
    }
    return originDataLocations;
  }, [originDataLocations]);
  const [dataInfo, setDataInfo] = useState({ data: [], loading: true, error: null })
  const [opciones, setOpciones] = useState({
    municipio: 0,
    tecnologia: 11,
    marca: 0,
    modelo: 0,
    fecha_ini: (() => {
      const d = new Date();
      d.setDate(d.getDate() - 30);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}T${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    })(),
    fecha_fin: '' + obtenerFechaActualLocal()
  })
  const [opcionesArray, setOpcionesArray] = useState({ municipio: [0], tecnologia: [11], marca: [0], modelo: [0] })
  const [opcionesTxtArray, setOpcionesTxtArray] = useState({ municipio: [lang[languaje]['todos'].toUpperCase()], tecnologia: ['SUSCRIPTORES'], marca: [lang[languaje]['todos'].toUpperCase()], modelo: [lang[languaje]['todos'].toUpperCase()] })
  const [opcionesTxtArrayFijo, setOpcionesTxtArrayFijo] = useState({ municipio: [lang[languaje]['todos'].toUpperCase()], tecnologia: ['SUSCRIPTORES'], marca: [lang[languaje]['todos'].toUpperCase()], modelo: [lang[languaje]['todos'].toUpperCase()] })
  const [prevOpcionesArray, setPrevOpcionesArray] = useState({ municipio: [-1], tecnologia: [-1], marca: [-1], modelo: [-1] })
  const token_item = localStorage.getItem('access_token')
  const [addMultiGraphModalOpen, setAddMultiGraphModalOpen] = useState(false);
  const [totalLienas, setTotalLineas] = useState(1)
  const [seriesKeys, setSeriesKeys] = useState([])
  const [seriesToRender, setSeriesToRender] = useState([])
  const [dataTec, setDataTec] = useState({ data: [[]], loading: [true], error: [null] })
  const [dataMarca, setDataMarca] = useState({ data: [[]], loading: [true], error: [null] })
  const [dataModelo, setDataModelo] = useState({ data: [[]], loading: [true], error: [null] })
  const [indexSelected, setIndexSelected] = useState(0)

  const [flagTodos, setFlagTodos] = useState(true)
  const [flagGeneral, setFlagGeneral] = useState(false)
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState(null);
  const [devices, setDevices] = useState({ data: [], loading: true, error: null });
  const [arrayHost, setArrayHost] = useState([])
  const [viewArrayHost, setViewArrayHost] = useState(true)
  const [reportbyHost, setReportByHost] = useState(false)
  const [databyHost, setDataByHost] = useState([])
  const [msgError, setMsgError] = useState("Ingrese un host para buscar datos")
  // console.log('flag todos',flagTodos)
  const predefinedRanges = [
    {
      label: capitalizeFirstLetter(lang[languaje]['UltimaHora']),
      value: [subHours(new Date(), 1), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['Ultima3Horas']),
      value: [subHours(new Date(), 3), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['Ultima6Horas']),
      value: [subHours(new Date(), 6), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['Ultima12Horas']),
      value: [subHours(new Date(), 12), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['Ultima24Horas']),
      value: [subHours(new Date(), 24), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['Ultima48Horas']),
      value: [subHours(new Date(), 48), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['estaSemana']),
      value: [startOfWeek(new Date()), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['semanaPasada']),
      value: [subDays(new Date(), 6), new Date()],
      placement: 'left'
    },

    {
      label: capitalizeFirstLetter(lang[languaje]['esteMes']),
      value: [startOfMonth(new Date()), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['mesPasado']),
      value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['esteAnio']),
      value: [new Date(new Date().getFullYear(), 0, 1), new Date()],
      placement: 'left'
    },
    {
      label: capitalizeFirstLetter(lang[languaje]['anioPasado']),
      value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)],
      placement: 'left'
    },


  ];

  const Ampliar = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setAddMultiGraphModalOpen(true)
  }
  function closAddMultiGraphModal() {

    setAddMultiGraphModalOpen(false);

  }
  useEffect(() => {
    // setSeriesToRender(seriesKeys.filter(key => data.some(item => item[key])));
    // console.log(seriesKeys.filter(key => data.some(item => item[key]))) // Filtra solo las series que tienen valores

  }, [seriesKeys])

  const ultimasNHoras = (n) => {
    const ahora = new Date();
    const haceNHoras = new Date(ahora.getTime() - (n * 60 * 60 * 1000));
    const anio = haceNHoras.getFullYear();
    const mes = String(haceNHoras.getMonth() + 1).padStart(2, '0');
    const dia = String(haceNHoras.getDate()).padStart(2, '0');
    const horas = String(haceNHoras.getHours()).padStart(2, '0');
    const minutos = String(haceNHoras.getMinutes()).padStart(2, '0');

    // setFechaInicio(haceTresHoras.toISOString().slice(0, 16));
    setOpciones((prevState) => {
      return {
        ...prevState,
        ['fecha_ini']: `${anio}-${mes}-${dia}T${horas}:${minutos}`,
        ['fecha_fin']: formatDate(ahora)
      }

    })
    // console.log(opciones)
    // setFechaFin(ahora.toISOString().slice(0, 16));
  };
  const formatDate = (date) => {
    const anio = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    const horas = String(date.getHours()).padStart(2, '0');
    const minutos = String(date.getMinutes()).padStart(2, '0');
    // console.log(`${anio}-${mes}-${dia}T${horas}:${minutos}`)
    return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
  }
  const ultimoPeriodo = (n) => {

    const fechaActual = new Date();
    const anioActual = new Date().getFullYear();
    // Calcula la fecha de inicio de la semana actual
    const inicioSemanaActual = new Date(fechaActual);
    inicioSemanaActual.setDate(fechaActual.getDate() - fechaActual.getDay());
    // Calcula la fecha de fin de la semana actual
    const finSemanaActual = new Date(fechaActual);
    finSemanaActual.setDate(fechaActual.getDate() + (6 - fechaActual.getDay()));
    // Resta 7 días para obtener la fecha de inicio de la semana pasada
    const inicioSemanaPasada = new Date(inicioSemanaActual);
    inicioSemanaPasada.setDate(inicioSemanaActual.getDate() - 7);
    // Resta 7 días para obtener la fecha de fin de la semana pasada
    const finSemanaPasada = new Date(finSemanaActual);
    finSemanaPasada.setDate(finSemanaActual.getDate() - 7);


    const primerDiaMesActual = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    // const primerDiaDelMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    const ultimoDiaMesPasado = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 0);

    // Calcula el primer día del mes pasado
    const primerDiaMesPasado = new Date(ultimoDiaMesPasado.getFullYear(), ultimoDiaMesPasado.getMonth(), 1);

    const primerDiaAnioPasado = new Date(fechaActual.getFullYear() - 1, 0, 1);

    // Calcula el último día del año pasado
    const ultimoDiaAnioPasado = new Date(fechaActual.getFullYear() - 1, 11, 31);
    const primerDiaAnoActual = new Date(anioActual, 0, 1);
    // return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
    // console.log(formatDate(inicioSemanaPasada))
    switch (n) {
      case 1:
        setOpciones((prevState) => {
          return {
            ...prevState,
            ['fecha_ini']: formatDate(inicioSemanaActual),
            ['fecha_fin']: formatDate(fechaActual)
          }
        })
        break;
      case 2:
        setOpciones((prevState) => {
          return {
            ...prevState,
            ['fecha_ini']: formatDate(inicioSemanaPasada),
            ['fecha_fin']: formatDate(finSemanaPasada)
          }
        })
        break;
      case 3:
        setOpciones((prevState) => {
          return {
            ...prevState,
            ['fecha_ini']: formatDate(primerDiaMesActual),
            ['fecha_fin']: formatDate(fechaActual)
          }
        })
        break;
      case 4:
        setOpciones((prevState) => {
          return {
            ...prevState,
            ['fecha_ini']: formatDate(primerDiaMesPasado),
            ['fecha_fin']: formatDate(ultimoDiaMesPasado)
          }
        })
        break;
      case 5:
        setOpciones((prevState) => {
          return {
            ...prevState,
            ['fecha_ini']: formatDate(primerDiaAnoActual),
            ['fecha_fin']: formatDate(fechaActual)
          }
        })
        break;
      case 6:
        setOpciones((prevState) => {
          return {
            ...prevState,
            ['fecha_ini']: formatDate(primerDiaAnioPasado),
            ['fecha_fin']: formatDate(ultimoDiaAnioPasado)
          }
        })
        break;
    }
    // setFechaInicio(haceTresHoras.toISOString().slice(0, 16));
    //   

  };

  useEffect(() => {
    // setSeriesKeys(countArray[elementos.length]) 
    search_reporte_disponibilidad()
    search_devices()
  }, [])

  useEffect(() => {
    accionar_reporte();
  }, [opcionesArray.tecnologia, opcionesArray.marca, opcionesArray.modelo])

  const Buscar = () => {

    search_reporte_disponibilidad()
  }
  const accionar_reporte = () => {
    if (reportbyHost) {

      search_reporte_host()
    } else {
      search_reporte_disponibilidad()
    }
  }
  function search_reporte_disponibilidad() {
    setIndexSelected(0)
    opcionesTxtArrayFijo.municipio = [...opcionesTxtArray.municipio]
    opcionesTxtArrayFijo.tecnologia = [...opcionesTxtArray.tecnologia]
    opcionesTxtArrayFijo.modelo = [...opcionesTxtArray.modelo]
    opcionesTxtArrayFijo.marca = [...opcionesTxtArray.marca]
    let baseURL
    // setSeriesKeys(countArray[elementos.length])
    // if(elementos.length==1){
    //   baseURL = server.url+'/api/v1/cassia/reports/availability';
    // }else{
    baseURL = server.url + '/api/v1/cassia/reports/availability/multiple';
    // }
    if (opcionesArray.municipio[0] == 0) {
      setFlagTodos(true)
      setFlagGeneral(false)
    } else {
      setFlagTodos(false)
      setFlagGeneral(true)
    }
    const municipioParam = opcionesArray.municipio.map(id => `municipality_id=${id}`).join('&');
    const tecParam = opcionesArray.tecnologia.map(id => `tech_id=${id}`).join('&');
    const marcaParam = opcionesArray.marca.map(id => `brand_id=${id}`).join('&');
    const modeloParam = opcionesArray.modelo.map(id => `model_id=${id}`).join('&');

    const url = `${baseURL}?${municipioParam}&${tecParam}&${marcaParam}&${modeloParam}&init_date=${opciones.fecha_ini}&end_date=${opciones.fecha_fin}`
    // console.log(url)  
    // console.log(server.url+'/api/v1/cassia/reports/availability?municipality_id='+opciones.municipio+'&tech_id='+opciones.tecnologia+'&brand_id='+opciones.marca+'&model_id='+opciones.modelo+'&init_date='+opciones.fecha_ini+'&end_date='+opciones.fecha_fin)
    setDataInfo({ data: dataInfo.data, loading: true, error: dataInfo.error })
    const fetchData = async () => {
      try {
        // MOCK DATA GENERATION BEGIN
        setTotalLineas(1);
        setDataByHost([]);

        setTimeout(() => {
          const startDate = new Date(opciones.fecha_ini);
          const endDate = new Date(opciones.fecha_fin);
          const diffTime = Math.abs(endDate - startDate);
          const diffDays = Math.max(1, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));

          let dataset = [];
          const numPoints = Math.min(30, Math.max(2, diffDays)); // max 30 data points
          const timeStep = diffTime / (numPoints - 1 || 1);

          let isTodos = opcionesArray.municipio[0] == 0;
          let municipalityList = ["Coyoacán", "Tlalpan", "Cuauhtémoc", "Miguel Hidalgo", "Benito Juárez"];

          let seriesCount = isTodos ? 5 : elementos.length;
          let selectedMunicipalities = isTodos
            ? municipalityList
            : Array.from({ length: seriesCount }, (_, s) => opcionesTxtArrayFijo.municipio[s] || `Serie ${s + 1}`);

          let generalFuncAvg = [];

          // Pre-generate average for each series
          for (let s = 0; s < seriesCount; s++) {
            let baseAvg = 70;
            let techId = opcionesArray.tecnologia[isTodos ? 0 : s] || 0;
            let brandId = opcionesArray.marca[isTodos ? 0 : s] || 0;
            let modelId = opcionesArray.modelo[isTodos ? 0 : s] || 0;

            if (techId != 11 && techId != 0) baseAvg -= 15;
            if (brandId != 0) baseAvg += 8;
            if (modelId != 0) baseAvg -= 5;

            let finalAvg = baseAvg + (Math.random() * 20 - 10);
            generalFuncAvg.push(Math.min(95, Math.max(40, finalAvg)));
          }

          for (let i = 0; i < numPoints; i++) {
            let curTime = new Date(startDate.getTime() + (timeStep * i));
            // format time like "2026-03-01T00:00"
            const formatNumber = (num) => num.toString().padStart(2, '0');
            let timeStr = `${curTime.getFullYear()}-${formatNumber(curTime.getMonth() + 1)}-${formatNumber(curTime.getDate())}T${formatNumber(curTime.getHours())}:${formatNumber(curTime.getMinutes())}`;

            let point = { "Tiempo": timeStr };

            let pointSum = 0;
            for (let s = 0; s < seriesCount; s++) {
              // Add some noise around the average
              let val = Math.min(100, Math.max(0, generalFuncAvg[s] + (Math.random() * 30 - 15)));
              pointSum += val;
              if (isTodos) {
                point[municipalityList[s]] = val;
              } else {
                point[`Disponibilidad_${s + 1}`] = val;
              }
            }
            point["Promedio"] = pointSum / seriesCount;
            dataset.push(point);
          }

          let indices = [];
          let days = [];
          let device_count = [];
          for (let s = 0; s < seriesCount; s++) {
            indices.push(s + 1);
            days.push(diffDays);
            device_count.push(Math.floor(Math.random() * 100) + 50);
          }

          const mockResponse = {
            data: {
              general_funcionality_average: generalFuncAvg,
              metrics: [
                {
                  metric_name: "CONECTIVIDAD",
                  days: days,
                  device_count: device_count,
                  municipality: selectedMunicipalities,
                  indices: isTodos ? indices : indices,
                  dataset: dataset,
                  dataset2: dataset,
                  availability_average: generalFuncAvg
                }
              ]
            }
          };

          setDataInfo({ data: mockResponse.data, loading: false, error: null });
        }, 500); // Simulate network delay
        // MOCK DATA GENERATION END
      } catch (error) {
        // Manejo de errores
        setMsgError("Ocurrio un error favor de intentar nuevamente...")
        setDataInfo({ data: dataInfo.data, loading: dataInfo.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }

  function search_reporte_host(hostID) {

    let baseURL
    setDataByHost([0])
    baseURL = server.url + '/api/v1/cassia/reports/availability/devices/multiple';

    const hostParam = arrayHost.map(objeto => `device_ids=${objeto.hostid}`).join('&');
    const url = `${baseURL}?${hostParam}&init_date=${opciones.fecha_ini}&end_date=${opciones.fecha_fin}`

    setDataInfo({ data: dataInfo.data, loading: true, error: dataInfo.error })
    const fetchData = async () => {
      try {
        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        // console.log(response)
        if (response.ok) {
          const response_data = await response.json();
          setDataByHost(response_data.data)
          //  setTotalLineas(1)
          setDataInfo({ data: response_data.data, loading: false, error: dataInfo.error })

        } else {
          setDataByHost([])
          setMsgError("Ocurrio un error favor de intentar nuevamente...")
          throw new Error('Error en la solicitud');

        }
      } catch (error) {
        // Manejo de errores
        setDataInfo({ data: dataInfo.data, loading: dataInfo.loading, error: error })
        console.error(error);
        setDataByHost([])
        setMsgError("Ocurrio un error favor de intentar nuevamente...")
      }
    };
    fetchData();
  }
  function download_reporte_host() {
    let baseURL
    // setSeriesKeys(countArray[elementos.length])
    // if(elementos.length==1){
    //   baseURL = server.url+'/api/v1/cassia/reports/availability';
    // }else{
    baseURL = server.url + '/api/v1/cassia/reports/availability/devices/multiple/download';
    // }


    const hostParam = arrayHost.map(objeto => `device_ids=${objeto.hostid}`).join('&');
    const url = `${baseURL}?${hostParam}&init_date=${opciones.fecha_ini}&end_date=${opciones.fecha_fin}`
    // console.log(url)  
    // console.log(server.url+'/api/v1/cassia/reports/availability?municipality_id='+opciones.municipio+'&tech_id='+opciones.tecnologia+'&brand_id='+opciones.marca+'&model_id='+opciones.modelo+'&init_date='+opciones.fecha_ini+'&end_date='+opciones.fecha_fin)
    // setDataInfo({data:dataInfo.data,loading:true,error:dataInfo.error})
    const fetchData = async () => {
      try {
        //  const response = await fetch(server.url+'/api/v1/cassia/reports/availability?municipality_id='+opciones.municipio+'&tech_id='+opciones.tecnologia+'&brand_id='+opciones.marca+'&model_id='+opciones.modelo+'&init_date='+opciones.fecha_ini+'&end_date='+opciones.fecha_fin, {     
        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          try {
            const response_data = await response.blob();
            // console.log(response_data)

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(response_data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'data_report.xlsx'); // Cambia el nombre y la extensión del archivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          } catch (error) {
            console.error('Error al descargar el archivo', error);
          }

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
      }
    };
    fetchData();
  }
  function download_reporte_disponibilidad() {
    let baseURL
    // setSeriesKeys(countArray[elementos.length])
    // if(elementos.length==1){
    //   baseURL = server.url+'/api/v1/cassia/reports/availability';
    // }else{
    baseURL = server.url + '/api/v1/cassia/reports/availability/multiple/download';
    // }

    const municipioParam = opcionesArray.municipio.map(id => `municipality_id=${id}`).join('&');
    const tecParam = opcionesArray.tecnologia.map(id => `tech_id=${id}`).join('&');
    const marcaParam = opcionesArray.marca.map(id => `brand_id=${id}`).join('&');
    const modeloParam = opcionesArray.modelo.map(id => `model_id=${id}`).join('&');

    const url = `${baseURL}?${municipioParam}&${tecParam}&${marcaParam}&${modeloParam}&init_date=${opciones.fecha_ini}&end_date=${opciones.fecha_fin}`
    // console.log(url)  
    // console.log(server.url+'/api/v1/cassia/reports/availability?municipality_id='+opciones.municipio+'&tech_id='+opciones.tecnologia+'&brand_id='+opciones.marca+'&model_id='+opciones.modelo+'&init_date='+opciones.fecha_ini+'&end_date='+opciones.fecha_fin)
    // setDataInfo({data:dataInfo.data,loading:true,error:dataInfo.error})
    const fetchData = async () => {
      try {
        //  const response = await fetch(server.url+'/api/v1/cassia/reports/availability?municipality_id='+opciones.municipio+'&tech_id='+opciones.tecnologia+'&brand_id='+opciones.marca+'&model_id='+opciones.modelo+'&init_date='+opciones.fecha_ini+'&end_date='+opciones.fecha_fin, {     
        const response = await fetch(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token_item}`,
          },
        });
        if (response.ok) {
          try {
            const response_data = await response.blob();
            // console.log(response_data)

            // Crear un enlace para descargar el archivo
            const url = window.URL.createObjectURL(response_data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'data_report.xlsx'); // Cambia el nombre y la extensión del archivo
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
          } catch (error) {
            console.error('Error al descargar el archivo', error);
          }

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
      }
    };
    fetchData();
  }
  const download = () => {
    if (reportbyHost) {
      download_reporte_host()
    } else {
      download_reporte_disponibilidad()
    }
  }
  const handleChangeOption = (index) => {
    setIndexSelected(index)
  }

  const generateColor = (progress) => {
    const purple = [128, 0, 128]; // Morado
    const blue = [0, 0, 255]; // Azul
    const green = [0, 128, 0]; // Verde

    let color;

    if (progress <= 0.5) {
      // En la primera mitad de la escala, interpolamos de morado a azul
      const factor = progress / 0.5;
      color = [
        Math.round(purple[0] + (blue[0] - purple[0]) * factor),
        Math.round(purple[1] + (blue[1] - purple[1]) * factor),
        Math.round(purple[2] + (blue[2] - purple[2]) * factor),
      ];
    } else {
      // En la segunda mitad de la escala, interpolamos de azul a verde
      const factor = (progress - 0.5) / 0.5;
      color = [
        Math.round(blue[0] + (green[0] - blue[0]) * factor),
        Math.round(blue[1] + (green[1] - blue[1]) * factor),
        Math.round(blue[2] + (green[2] - blue[2]) * factor),
      ];
    }

    return `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
  };

  // Uso
  const progress = 0.5;
  const [elementos, setElementos] = useState(['Serie 1']);

  const [elementosToRender, setElementosToRender] = useState(['Disponibilidad_1']);
  const [disabled, setDisabled] = useState(true)
  // console.log(elementos)
  // console.log(elementosToRender)
  const handleClickAdd = () => {
    // console.log(dataLocations.data.data[0].id,dataLocations.data.data[0].name)

    setElementos([...elementos, 'Serie ' + (parseInt(elementos.length, 10) + 1)]);
    setElementosToRender([...elementosToRender, 'Disponibilidad_' + (parseInt(elementosToRender.length, 10) + 1)]);
    setOpcionesArray(prevState => {
      return {
        ...prevState,
        municipio: [...prevState.municipio, dataLocations.data.data[0].id],
        tecnologia: [...prevState.tecnologia, 11],
        marca: [...prevState.marca, 0],
        modelo: [...prevState.modelo, 0]
      };
    });
    setOpcionesTxtArray(prevState => {
      return {
        ...prevState,
        municipio: [...prevState.municipio, dataLocations.data.data[0].name],
        tecnologia: [...prevState.tecnologia, 'SUSCRIPTORES'],
        marca: [...prevState.marca, lang[languaje]['todos'].toUpperCase()],
        modelo: [...prevState.modelo, lang[languaje]['todos'].toUpperCase()]
      };
    });
    setDataTec(prevState => {
      return {
        ...prevState,
        data: [...prevState.data, []],
        loading: [...prevState.loading, true],
        error: [...prevState.error, null],
      };
    });
    setDataMarca(prevState => {
      return {
        ...prevState,
        data: [...prevState.data, []],
        loading: [...prevState.loading, true],
        error: [...prevState.error, null],
      };
    });
    setDataModelo(prevState => {
      return {
        ...prevState,
        data: [...prevState.data, []],
        loading: [...prevState.loading, true],
        error: [...prevState.error, null],
      };
    });
    setTotalLineas(elementos.length + 1)

    if (elementos.length + 1 >= 1) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  };
  useEffect(() => {
    setViewArrayHost(true)
    const hostParam = arrayHost.map(objeto => `model_id=${objeto.hostid}`).join('&');
  }, [arrayHost])
  const eliminarElementoHost = (indice) => {
    setViewArrayHost(false)
    if (arrayHost.length == 1 && indice === 0) {
      setMsgError("Ingrese un host para buscar datos")
      setDataByHost([])
      setDataInfo({ data: [], loading: false, error: null })
    }
    const nuevoArreglo = [...arrayHost];
    // Usar splice para eliminar el objeto en la posición "indice"
    nuevoArreglo.splice(indice, 1);
    // Actualizar el estado con la nueva copia del arreglo
    setArrayHost(nuevoArreglo);

    //  setArrayHost(...arrayHost.splice(indice,1))

    //  setViewArrayHost(true)
  };
  const eliminarElemento = (indice) => {
    const nuevosElementos = elementos.filter((elemento, index) => index !== indice);
    const nuevosElementosTR = elementosToRender.filter((elemento, index) => index !== indice);
    // const newOpcionesArray=opcionesArray.filter((elemento, index) => index !== indice);
    // const newPrevOpcionesArray=prevOpcionesArray.filter((elemento, index) => index !== indice);
    setElementos(nuevosElementos);
    setElementosToRender(nuevosElementosTR);
    const newOpcionesArray = { ...opcionesArray };
    const newOpcionesTxtArray = { ...opcionesTxtArray };
    for (let propiedad in newOpcionesArray) {
      if (Array.isArray(newOpcionesArray[propiedad])) {
        newOpcionesArray[propiedad].splice(indice, 1);
      }
    }
    for (let propiedad in newOpcionesTxtArray) {
      if (Array.isArray(newOpcionesTxtArray[propiedad])) {
        newOpcionesTxtArray[propiedad].splice(indice, 1);
      }
    }
    setOpcionesArray(newOpcionesArray);
    setOpcionesTxtArray(newOpcionesTxtArray);

    const newPrevOpcionesArray = { ...prevOpcionesArray };

    for (let propiedad in newPrevOpcionesArray) {
      if (Array.isArray(newPrevOpcionesArray[propiedad])) {
        newPrevOpcionesArray[propiedad].splice(indice, 1);
      }
    }

    setPrevOpcionesArray(newPrevOpcionesArray);
    if (elementos.length - 1 >= 1) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  };
  const containerRef = useRef();
  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener('wheel', (e) => {
      e.preventDefault();
      container.scrollTop += e.deltaY;
    });
  }, []);
  const handleChangeGraf = (e) => {
    // console.log(e.target)
    const { name, value } = e.target

    setOpciones((prevState) => {
      return {
        ...prevState,
        [name]: value
      }
    })
  }

  const [flagSearch, setFlagSearch] = useState(true)
  const [resultList, setResultList] = useState([])
  const [inputIp, setInputIP] = useState("")
  const [chekedSearch, setChekedSearch] = useState(true)
  const closeFindHost = () => {
    const popups = document.querySelectorAll('.custom-popup-findHost');

    popups.forEach(popup => {
      //    console.log(popups)
      popup.remove();
    });
    setResultList([])
    setInputIP("")
  }

  const handleChangeSeacrhHost = (e) => {

    const term = e.target.value;
    const { name, value } = e.target
    // console.log(value)
    setInputIP(value)
    validateIp(value)

    const hostArray = devices.data.hosts
    const filteredResults = hostArray.filter((item) => {
      // Convierte todos los valores a cadenas para realizar una búsqueda sin distinción entre mayúsculas y minúsculas
      return Object.entries(item).some(([key, value]) => {
        if (key === 'ip' || key === 'Host' || key === 'name') {
          return String(value).toLowerCase().includes(term.toLowerCase());
        }
        return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
      });
    });
    setResultList(filteredResults)

  }
  const validateIp = (ip) => {
    // console.log("validando correo: ",ip )
    const ipRegex = /^$/;
    // const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    let result = ipRegex.test(ip);
    setFlagSearch(result)
    return result;
  };
  // console.log((typeof(dataInfo.data.metrics)!=='undefined')?dataInfo.data.metrics[0]:'') 
  // console.log(elementosToRender)
  // console.log(dataInfo.data.metrics[indexSelected].metric_name+"_"+(parseInt(0)+parseInt(1)))

  function search_devices() {


    setDevices({ data: devices.data, loading: true, error: devices.error })


    const fetchData = async () => {
      try {
        //console.log(`Bearer ${token_item}`)
        const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJqdWFuLm1hcmNpYWwiLCJleHAiOjE2OTExNjg3ODZ9.LETk5Nu-2WXF571qMqTd__RxHGcyOHzg4GfAbiFejJY'; // Reemplaza con tu token de autenticación
        // const response = await fetch(server.url+'/api/v1/zabbix/db/hosts/relations/'+ubicacion.groupid, {
        const devicefilter = ''
        const subtypefilter = ''
        let andAux = (devicefilter !== '') ? '&' : '?'
        andAux = (subtypefilter !== '') ? andAux : ''
        // console.log(server.url+'/api/v1/zabbix/hosts/'+ubicacion.groupid+''+devicefilter+andAux+subtypefilter)
        const response = await fetch(server.url + '/api/v1/zabbix/hosts/' + '0' + '' + devicefilter + andAux + subtypefilter, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
        });

        if (response.ok) {
          const response_data = await response.json();
          setDevices({ data: response_data.data, loading: false, error: devices.error })
          // console.log(response_data)

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        setDevices({ data: devices.data, loading: devices.loading, error: error })
        //console.error(error);
      }
    };
    fetchData();
  }
  const handleSelected = (element) => {
    setResultList([])
    setChekedSearch(true)
    setFlagSearch(true)
    setInputIP("")
    // setViewArrayHost(false)
    if (!arrayHost.includes(element)) {
      setArrayHost(prevArreglo => [...prevArreglo, element]);

    }
  }
  const porHost = () => {
    setOpcionesArray({ municipio: [0], tecnologia: [11], marca: [0], modelo: [0] })
    setOpcionesTxtArray({ municipio: [lang[languaje]['todos'].toUpperCase()], tecnologia: ['SUSCRIPTORES'], marca: [lang[languaje]['todos'].toUpperCase()], modelo: [lang[languaje]['todos'].toUpperCase()] })
    setOpcionesTxtArrayFijo({ municipio: [lang[languaje]['todos'].toUpperCase()], tecnologia: ['SUSCRIPTORES'], marca: [lang[languaje]['todos'].toUpperCase()], modelo: [lang[languaje]['todos'].toUpperCase()] })
    setDataInfo({ data: [], loading: false, error: null })
    setFlagGeneral(!flagGeneral)
    if (reportbyHost) {
      setArrayHost([])
      setDataByHost([])
      search_reporte_disponibilidad()
    }
    setReportByHost(!reportbyHost);

  }

  const [range, setRange] = useState([subDays(new Date(), 30), new Date()]);
  useEffect(() => {
    if (range != null && range[0] != null && range[1] != null) {
      setOpciones((prevState) => {
        return {
          ...prevState,
          ['fecha_ini']: formatDate(range[0]),
          ['fecha_fin']: formatDate(range[1])
        }

      })
    }


  }, [range])
  const [placement, setPlacement] = useState('leftStart'); // Default for desktop

  useEffect(() => {
    // Detect screen width and update placement dynamically
    const updatePlacement = () => {
      setPlacement(window.innerWidth < 768 ? 'bottomStart' : 'leftStart'); // Below 768px is considered mobile
    };

    // Initial setup and event listener
    updatePlacement();
    window.addEventListener('resize', updatePlacement);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', updatePlacement);
  }, []);

  return (
    <>
      <div className="disp-container disp-fade-in">
        {/* Header */}
        <div className="disp-header">
          <div className="disp-header-actions">
            <button className="disp-btn-primary" onClick={() => accionar_reporte()} disabled={false}>
              {capitalizeFirstLetter(lang[languaje]['buscar'])}
            </button>
          </div>
          <div>
            <DateRangePicker
              value={range}
              ranges={predefinedRanges}
              onChange={(value) => setRange(value)}
              className="reporte-gs-datepicker"
              placeholder="Seleccione un rango de fechas"
              showOneCalendar={false}
              format="yyyy-MM-dd HH:mm"
              showMeridian
              size='xs'
              placement={placement}
              shouldDisableDate={date => isAfter(date, new Date())}
            />
          </div>
        </div>

        <div className="disp-main-layout">
          {/* Sidebar */}
          {/* <div className="disp-sidebar">
            <div className="disp-sidebar-title">Métricas</div>
            {(dataInfo.data.length === 0 || dataInfo.loading) ? '' :
              dataInfo.data.metrics.map((key, index) => (
                index === 0 ? (
                  <label key={index} className="disp-metric-item">
                    <input
                      name="radio"
                      type="radio"
                      defaultChecked={index === 0}
                      onClick={() => handleChangeOption(index)}
                    />
                    <span className="disp-metric-label">
                      {lang[languaje][dataInfo.data.metrics[index].metric_name.toLowerCase()]}
                    </span>
                  </label>
                ) : null
              ))
            }
          </div> */}

          {/* Content */}
          <div className="disp-content">

            {/* Filters Section */}
            {!reportbyHost && (
              <div className="disp-filters-section">
                <div className="disp-filters-header">
                  {(elementos.length < 3 && (opcionesArray.municipio[0] != 0)) && (
                    <button className="disp-btn-add" onClick={handleClickAdd} title="Agregar Serie">
                      +
                    </button>
                  )}
                </div>

                <div className="disp-grid-table">
                  <div className="disp-grid-header">
                    <div>#</div>
                    <div>{capitalizeFirstLetter(lang[languaje]['municipio'])}</div>
                    <div>{capitalizeFirstLetter(lang[languaje]['tecnologia'])}</div>
                    <div>{capitalizeFirstLetter(lang[languaje]['marca'])}</div>
                    <div>{capitalizeFirstLetter(lang[languaje]['modelo'])}</div>
                    <div style={{ textAlign: 'center' }}>Eliminar</div>
                  </div>

                  <div ref={containerRef} style={{ overflow: 'visible' }}>
                    {elementos.map((elemento, index) => (
                      <div key={index} className="disp-grid-row">
                        <div className="disp-serie-name">
                          <span className="disp-bullet" style={{ backgroundColor: color_graf[index + 1] }}></span>
                          <span style={{ color: color_graf[index + 1] }}>Serie {elemento.replace('Serie ', '')}</span>
                        </div>

                        <div className="disp-menu-search-container">
                          <MenuSearch
                            languaje={languaje}
                            dataLocations={dataLocations}
                            eliminarElemento={eliminarElemento}
                            setElementos={setElementos}
                            dataTec={dataTec}
                            setDataTec={setDataTec}
                            dataModelo={dataModelo}
                            setDataModelo={setDataModelo}
                            dataMarca={dataMarca}
                            setDataMarca={setDataMarca}
                            index={index}
                            prevOpcionesArray={prevOpcionesArray}
                            setPrevOpcionesArray={setPrevOpcionesArray}
                            opcionesArray={opcionesArray}
                            opcionesTxtArray={opcionesTxtArray}
                            setOpcionesTxtArray={setOpcionesTxtArray}
                            setOpcionesArray={setOpcionesArray}
                            server={server}
                            opciones={opciones}
                            setOpciones={setOpciones}
                            completo={false}
                          />
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          {(index !== 0 && index == elementos.length - 1) && (
                            <button
                              className="disp-btn-icon danger"
                              title="Eliminar"
                              onClick={() => eliminarElemento(index)}
                            >
                              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                              </svg>
                            </button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            {/* Chart Card */}
            <div className="disp-card">
              <div className="disp-card-header">
                {(!reportbyHost && !dataInfo.loading && typeof (dataInfo.data.metrics) !== 'undefined') ? (
                  <label className="disp-checkbox-wrapper">
                    <input
                      type="checkbox"
                      checked={flagGeneral}
                      onChange={() => setFlagGeneral(!flagGeneral)}
                    />
                    <span>{capitalizeFirstLetter(lang[languaje]['promedio'])}</span>
                  </label>
                ) : <div></div>}

                <div style={{ display: 'flex', gap: '8px' }}>
                  <button className="disp-btn-icon" title="Descargar" onClick={download}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                  </button>
                  <button className="disp-btn-icon" title="Expandir" onClick={Ampliar}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
                    </svg>
                  </button>
                </div>
              </div>

              <div className="disp-chart-area">
                {(dataInfo.loading || typeof (dataInfo.data.metrics) === 'undefined') ? (
                  <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'var(--disp-text-secondary)' }}>
                    {(reportbyHost && databyHost.length === 0) ? msgError : <LoadSimple />}
                  </div>
                ) : (!reportbyHost || (reportbyHost && arrayHost.length > 0)) ? (
                  <>
                    {dataInfo.data.metrics[indexSelected].dataset.length === 0 && (
                      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: 'var(--disp-text-secondary)', fontSize: '18px', fontWeight: 500 }}>
                        Sin Datos
                      </div>
                    )}
                    <ResponsiveContainer width="100%" height="100%">
                      <AreaChart
                        data={dataInfo.data.metrics[indexSelected].dataset}
                        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" stroke="var(--disp-border)" vertical={false} />
                        <XAxis
                          dataKey="Tiempo"
                          stroke="var(--disp-text-secondary)"
                          tick={{ fontSize: 12 }}
                          tickLine={false}
                          axisLine={false}
                          dy={10}
                        />
                        <YAxis
                          domain={[0, 100]}
                          stroke="var(--disp-text-secondary)"
                          tick={{ fontSize: 12 }}
                          tickLine={false}
                          axisLine={false}
                          dx={-10}
                        />
                        <Tooltip content={<CustomTooltip />} />

                        {opcionesArray.municipio[0] === 0 ?
                          dataInfo.data.metrics[indexSelected].municipality.map((key, index) => (
                            <Area
                              key={index}
                              type="monotone"
                              name={key}
                              dataKey={key}
                              stroke={color_graf[((index + 1) > 50) ? (index + 1) - 50 : (index + 1)]}
                              fill={color_graf[((index + 1) > 50) ? (index + 1) - 50 : (index + 1)]}
                              fillOpacity={0.15}
                              strokeWidth={2}
                            />
                          ))
                          :
                          dataInfo.data.metrics[indexSelected].indices.map((key, index) => {
                            const areaName = dataInfo.data.metrics[indexSelected].municipality ? dataInfo.data.metrics[indexSelected].municipality[index] : ("Serie " + key);
                            return (
                              <Area
                                key={index}
                                type="monotone"
                                name={areaName}
                                dataKey={((reportbyHost) ? dataInfo.data.metrics[indexSelected].hostids[index] : "Disponibilidad_" + key)}
                                stroke={color_graf[((index + 1) > 50) ? (index + 1) - 50 : (index + 1)]}
                                fill={color_graf[((index + 1) > 50) ? (index + 1) - 50 : (index + 1)]}
                                fillOpacity={0.15}
                                strokeWidth={2}
                                activeDot={{ onClick: (e) => { }, r: 6 }}
                              />
                            );
                          })
                        }

                        {flagGeneral && (
                          <Area
                            type="monotone"
                            dataKey="Promedio"
                            name="Promedio"
                            stroke="#64748b"
                            fill="#64748b"
                            fillOpacity={0.1}
                            strokeWidth={2}
                            strokeDasharray="5 5"
                            activeDot={false}
                          />
                        )}
                      </AreaChart>
                    </ResponsiveContainer>
                  </>
                ) : null}
              </div>

              {/* Chart Footer Stats */}
              <div className="disp-chart-footer">
                <div className="disp-stat-group">
                  <div className="disp-stat-label">{capitalizeFirstLetter(lang[languaje]['funcPromedio'])}</div>
                  <div className="disp-stat-values">
                    {(typeof dataInfo.data.metrics !== 'undefined' && !dataInfo.loading) ? (
                      dataInfo.data.general_funcionality_average.map((key, index) => (
                        <div key={index} className="disp-stat-value" style={{ color: color_graf[index + 1] }}>
                          <span className="disp-bullet" style={{ backgroundColor: color_graf[index + 1] }}></span>
                          {typeof dataInfo.data.general_funcionality_average === 'undefined' ? '---' : ((dataInfo.data.general_funcionality_average[index] === "" ? 0 : dataInfo.data.general_funcionality_average[index].toFixed(2)))}%
                        </div>
                      ))
                    ) : <span className="disp-stat-value" style={{ color: 'var(--disp-text-secondary)' }}>---</span>}
                  </div>
                </div>

                <div className="disp-stat-group">
                  <div className="disp-stat-label">{capitalizeFirstLetter(lang[languaje]['lapsoTiempo'])}</div>
                  <div className="disp-stat-values">
                    {(typeof dataInfo.data.metrics !== 'undefined' && !dataInfo.loading) ? (
                      dataInfo.data.metrics[0].days.map((key, index) => (
                        <div key={index} className="disp-stat-value" style={{ color: color_graf[index + 1] }}>
                          <span className="disp-bullet" style={{ backgroundColor: color_graf[index + 1] }}></span>
                          {typeof dataInfo.data.metrics === 'undefined' ? '---' : ((dataInfo.data.metrics[0].days[index] === "" ? 0 : dataInfo.data.metrics[0].days[index].toFixed(2)))} {capitalizeFirstLetter(lang[languaje]['dias'])}
                        </div>
                      ))
                    ) : <span className="disp-stat-value" style={{ color: 'var(--disp-text-secondary)' }}>---</span>}
                  </div>
                </div>

                <div className="disp-stat-group">
                  <div className="disp-stat-label">{capitalizeFirstLetter(lang[languaje]['dispositivos'])}</div>
                  <div className="disp-stat-values">
                    {(typeof dataInfo.data.metrics !== 'undefined' && !dataInfo.loading) ? (
                      dataInfo.data.metrics[0].device_count.map((key, index) => (
                        <div key={index} className="disp-stat-value" style={{ color: color_graf[index + 1] }}>
                          <span className="disp-bullet" style={{ backgroundColor: color_graf[index + 1] }}></span>
                          {typeof dataInfo.data.metrics === 'undefined' ? '---' : ((dataInfo.data.metrics[0].device_count[index] === "" ? 0 : dataInfo.data.metrics[0].device_count[index]))}
                        </div>
                      ))
                    ) : <span className="disp-stat-value" style={{ color: 'var(--disp-text-secondary)' }}>---</span>}
                  </div>
                </div>
              </div>
            </div>

            {/* Results Table */}
            <div className="disp-results-table">
              <div className="disp-results-header">
                <div>Serie</div>
                <div>{capitalizeFirstLetter(lang[languaje]['metrica'])}</div>
                <div>{capitalizeFirstLetter(lang[languaje]['dispPromedio'])}</div>
                <div>{capitalizeFirstLetter(lang[languaje]['dias'])}</div>
                <div>{capitalizeFirstLetter(lang[languaje]['dispositivos'])}</div>
              </div>

              <div>
                {(dataInfo.data.length === 0 || dataInfo.loading) ? null : (
                  dataInfo.data.metrics.map((metric, index) => (
                    metric.availability_average.map((avail, index2) => {
                      const seriesName = (metric.municipality && metric.municipality[index2]) ? metric.municipality[index2] : ('Serie ' + metric.indices[index2]);
                      const seriesColor = getMunicipalityColor(seriesName, metric.indices[index2]) || color_graf[index2 + 1];

                      return (
                        <div key={`${index}-${index2}`} className="disp-results-row">
                          <div className="disp-serie-name" style={{ color: seriesColor }}>
                            {seriesName}
                          </div>
                          <div style={{ fontSize: '13px', fontWeight: 500 }}>
                            {lang[languaje][metric.metric_name.toLowerCase()]}
                          </div>
                          <div className="disp-results-val">
                            {typeof metric.availability_average === 'undefined' ? '---' : ((avail === "" ? 0 : avail.toFixed(2)))}%
                          </div>
                          <div className="disp-results-val">
                            {typeof metric.days === 'undefined' ? '---' : ((metric.days[index2] === "" ? 0 : metric.days[index2].toFixed(2)))} {capitalizeFirstLetter(lang[languaje]['dias'])}
                          </div>
                          <div className="disp-results-val">
                            {typeof metric.device_count === 'undefined' ? '---' : ((metric.device_count[index2] === "" ? 0 : metric.device_count[index2]))}
                          </div>
                        </div>
                      );
                    })
                  ))
                )}
              </div>
            </div>

          </div>
        </div>
      </div>

      <Modal
        isOpen={addMultiGraphModalOpen}
        onRequestClose={closAddMultiGraphModal}
        style={AddMultiGraphModalStyles}
        contentLabel="Example Modal2"
      >
        <ModalAddMultiGraph
          reportbyHost={reportbyHost}
          arrayHost={arrayHost}
          databyHost={databyHost}
          msgError={msgError}
          flagTodos={flagTodos}
          flagGeneral={flagGeneral}
          setFlagGeneral={setFlagGeneral}
          generateColorOptions={generateColorOptions}
          indexSelected={indexSelected}
          dataInfo={dataInfo}
          elementosToRender={elementosToRender}
          closAddMultiGraphModal={closAddMultiGraphModal}
          setTotalLineas={setTotalLineas}
          color_graf={color_graf}
          opcionesTxtArrayFijo={opcionesTxtArrayFijo}
        />
      </Modal>
    </>
  );
}

export default Disponibilidad
